export const chatmonitoringConstants = {

    FETCH_ACTIVECLASSES_REQUEST: 'FETCH_ACTIVECLASSES_REQUEST',
    FETCH_ACTIVECLASSES_SUCCESS: 'FETCH_ACTIVECLASSES_SUCCESS',
    FETCH_ACTIVECLASSES_FAILURE: 'FETCH_ACTIVECLASSES_FAILURE',

    GET_ACTIVECLASSSTUDENTS_REQUEST: 'GET_ACTIVECLASSSTUDENTS_REQUEST',
    GET_ACTIVECLASSSTUDENTS_SUCCESS: 'GET_ACTIVECLASSSTUDENTS_SUCCESS',
    GET_ACTIVECLASSSTUDENTS_FAILURE: 'GET_ACTIVECLASSSTUDENTS_FAILURE',

    FETCH_FLAGGEDMESSAGES_REQUEST: 'FETCH_FLAGGEDMESSAGES_REQUEST',
    FETCH_FLAGGEDMESSAGES_SUCCESS: 'FETCH_FLAGGEDMESSAGES_SUCCESS',
    FETCH_FLAGGEDMESSAGES_FAILURE: 'FETCH_FLAGGEDMESSAGES_FAILURE',

    FETCH_REPORTEDMESSAGES_REQUEST: 'FETCH_REPORTEDMESSAGES_REQUEST',
    FETCH_REPORTEDMESSAGES_SUCCESS: 'FETCH_REPORTEDMESSAGES_SUCCESS',
    FETCH_REPORTEDMESSAGES_FAILURE: 'FETCH_REPORTEDMESSAGES_FAILURE',

    UPDATE_AWARDCOINS_REQUEST: 'UPDATE_AWARDCOINS_REQUEST',
    UPDATE_AWARDCOINS_SUCCESS: 'UPDATE_AWARDCOINS_SUCCESS',
    UPDATE_AWARDCOINS_FAILURE: 'UPDATE_AWARDCOINS_FAILURE',

    UPDATE_STUDENTBLOCKS_REQUEST: 'UPDATE_STUDENTBLOCKS_REQUEST',
    UPDATE_STUDENTBLOCKS_SUCCESS: 'UPDATE_STUDENTBLOCKS_SUCCESS',
    UPDATE_STUDENTBLOCKS_FAILURE: 'UPDATE_STUDENTBLOCKS_FAILURE',

    FETCH_CHATUSERNAME_REQUEST: 'FETCH_CHATUSERNAME_REQUEST',
    FETCH_CHATUSERNAME_SUCCESS: 'FETCH_CHATUSERNAME_SUCCESS',
    FETCH_CHATUSERNAME_FAILURE: 'FETCH_CHATUSERNAME_FAILURE',

    UPDATE_CHATUSERNAME_REQUEST: 'UPDATE_CHATUSERNAME_REQUEST',
    UPDATE_CHATUSERNAME_SUCCESS: 'UPDATE_CHATUSERNAME_SUCCESS',
    UPDATE_CHATUSERNAME_FAILURE: 'UPDATE_CHATUSERNAME_FAILURE',

    FETCH_APPCONFIGS_REQUEST: 'FETCH_APPCONFIGS_REQUEST',
    FETCH_APPCONFIGS_SUCCESS: 'FETCH_APPCONFIGS_SUCCESS',
    FETCH_APPCONFIGS_FAILURE: 'FETCH_APPCONFIGS_FAILURE',

    HYDRATE_CHATMONITORING_DATA: 'HYDRATE_CHATMONITORING_DATA',
    RESET_CHATMONITORING_DATA: 'RESET_CHATMONITORING_DATA',

}
